import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import AppleSigninButton from '@components/applesignin/AppleSigninButton';
import SocialButton from '@components/login/SocialButton';
import Button from '@stone/ui/button/Button';
const OtherLoginMethods = (props) => {
    const { t } = useTranslation();
    const filteredMethods = useMemo(() => {
        return props.loginMethods.filter((e, i) => {
            if (props.loginStep == 'social-login') {
                return i != 0;
            }
            else {
                return e.ID != 'email';
            }
        });
    }, [props.loginMethods, props.loginStep]);
    return props.loginStep == 'social-login' && filteredMethods.length == 0 ? (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "mb-32" }, t('label.signinwithemail')),
        React.createElement("div", { className: "other-login-methods" },
            React.createElement(Button, { type: "button", className: "full", onClick: () => props.setLoginStep('register'), cls: ['button--primary'] }, t('login.registerwithpassword'))))) : (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "mb-32" }, t('label.signinwithother')),
        React.createElement("div", { className: "other-login-methods" }, filteredMethods.map((login, index) => {
            return (React.createElement("div", { key: index },
                login.ID == 'Google' && React.createElement(SocialButton, { social: "google", secondary: true, reloadUrl: location.href }),
                login.ID == 'Facebook' && React.createElement(SocialButton, { social: "facebook", secondary: false, reloadUrl: location.href }),
                login.ID == 'Apple' && React.createElement(AppleSigninButton, { secondary: true }),
                login.ID == 'email' && (React.createElement(Button, { type: "button", className: "full", onClick: () => props.setLoginStep('password'), cls: ['button--primary'] }, t('login.logintomymoncler')))));
        }))));
};
export default OtherLoginMethods;
